var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotlightMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 43,
    viewBox: "0 0 27 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_481)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11_481)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 39.5,
    rx: 4.5,
    ry: 2.5,
    fill: "black",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_11_481",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 40,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 27,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13.5C26 16.3253 25.0627 18.9316 23.4821 21.025C22.9203 21.8066 22.1609 22.6384 21.3202 23.5591C18.4001 26.7571 14.5 31.0285 14.5 38C14.5 38.5523 14.0523 39 13.5 39C12.9477 39 12.5 38.5523 12.5 38C12.5 31.0285 8.59989 26.7571 5.67984 23.5591C4.83915 22.6384 4.07969 21.8066 3.51793 21.025C1.93731 18.9316 1 16.3253 1 13.5C1 6.59644 6.59644 1 13.5 1C20.4036 1 26 6.59644 26 13.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13.5C26 16.3253 25.0627 18.9316 23.4821 21.025C22.9203 21.8066 22.1609 22.6384 21.3202 23.5591C18.4001 26.7571 14.5 31.0285 14.5 38C14.5 38.5523 14.0523 39 13.5 39C12.9477 39 12.5 38.5523 12.5 38C12.5 31.0285 8.59989 26.7571 5.67984 23.5591C4.83915 22.6384 4.07969 21.8066 3.51793 21.025C1.93731 18.9316 1 16.3253 1 13.5C1 6.59644 6.59644 1 13.5 1C20.4036 1 26 6.59644 26 13.5Z",
    fill: "#EA352B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4821 21.025L22.684 20.4224L22.6769 20.4318L22.67 20.4414L23.4821 21.025ZM21.3202 23.5591L22.0586 24.2334L21.3202 23.5591ZM5.67984 23.5591L6.41831 22.8848L6.41831 22.8848L5.67984 23.5591ZM3.51793 21.025L4.32995 20.4414L4.32309 20.4318L4.316 20.4225L3.51793 21.025ZM24.2801 21.6276C25.9873 19.3666 27 16.5501 27 13.5H25C25 16.1004 24.1381 18.4966 22.684 20.4224L24.2801 21.6276ZM22.0586 24.2334C22.8872 23.326 23.6911 22.4477 24.2941 21.6086L22.67 20.4414C22.1496 21.1656 21.4345 21.9508 20.5817 22.8848L22.0586 24.2334ZM15.5 38C15.5 31.4506 19.1345 27.4359 22.0586 24.2334L20.5817 22.8848C17.6658 26.0783 13.5 30.6065 13.5 38H15.5ZM13.5 40C14.6046 40 15.5 39.1046 15.5 38H13.5V40ZM11.5 38C11.5 39.1046 12.3954 40 13.5 40V38H11.5ZM4.94136 24.2334C7.86553 27.4359 11.5 31.4506 11.5 38H13.5C13.5 30.6065 9.33425 26.0783 6.41831 22.8848L4.94136 24.2334ZM2.70591 21.6087C3.30894 22.4477 4.11284 23.326 4.94136 24.2334L6.41831 22.8848C5.56546 21.9508 4.85045 21.1656 4.32995 20.4414L2.70591 21.6087ZM0 13.5C0 16.5501 1.01274 19.3666 2.71987 21.6276L4.316 20.4225C2.86188 18.4966 2 16.1004 2 13.5H0ZM13.5 0C6.04416 0 0 6.04416 0 13.5H2C2 7.14873 7.14873 2 13.5 2V0ZM27 13.5C27 6.04416 20.9558 0 13.5 0V2C19.8513 2 25 7.14873 25 13.5H27Z",
    fill: "url(#paint0_linear_11_481)",
    mask: "url(#path-2-outside-1_11_481)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 4.5,
    fill: "black",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11_481",
    x: 7,
    y: 35,
    width: 13,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_11_481"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_481",
    x1: 13.5,
    y1: 1,
    x2: 13.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlightMarker);
export default __webpack_public_path__ + "static/media/Spotlight Marker.8c00f0f68f6b9ae31ee6db0ea4033716.svg";
export { ForwardRef as ReactComponent };